/** Target route to offer when leaving the full-screen error page (sessionStorage). */
export const ERROR_RETURN_PATH_STORAGE_KEY = 'app.error.returnPath'

export function rememberReturnPathBeforeError(fullPath: string): void {
  try {
    if (!fullPath || fullPath === '/error' || fullPath.startsWith('/error?')) {
      return
    }
    sessionStorage.setItem(ERROR_RETURN_PATH_STORAGE_KEY, fullPath)
  } catch {
    // ignore quota / disabled storage
  }
}

export function clearErrorReturnPath(): void {
  try {
    sessionStorage.removeItem(ERROR_RETURN_PATH_STORAGE_KEY)
  } catch {
    // ignore
  }
}
